
import { useStore, UserData } from '../store';
import { defineComponent } from 'vue';
import { ExerciseSession } from '../views/ExerciseSession.vue';

export default defineComponent({
	name: 'Home',
	setup() {
		return { store: useStore() };
	},
	data() {
		return {
			displayData: Array<ExerciseSession>()
		};
	},
	computed: {
		showExercises(): boolean {
			let userData = new UserData(this.store.getState().userData.days);
			if (userData.days.length !== 0) {
				this.updateDisplayData();
				return true;
			} else return false;
		}
	},
	methods: {
		updateDisplayData(): void {
			this.displayData = new Array<ExerciseSession>();
			const convData = this.store.getState().convenienceData;
			const pattern = new RegExp(/^\d{4}-\d\d-\d\d$/);
			for (let i = 0; i < convData.days.length; i++) {
				let { exercise, date } = convData.days[i];
				date = pattern.test(date) ? date : 'No workout yet!';
				const nextAS = new ExerciseSession(exercise, date);
				this.displayData.unshift(nextAS);
			}
		}
	}
});
